import { render, staticRenderFns } from "./WidgetBuilder.vue?vue&type=template&id=8ac80f16"
import script from "./WidgetBuilder.vue?vue&type=script&lang=js"
export * from "./WidgetBuilder.vue?vue&type=script&lang=js"
import style0 from "./WidgetBuilder.vue?vue&type=style&index=0&id=8ac80f16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports